import { StyleSheet } from 'react-native'

const useStyles = (isTablet) => StyleSheet.create({
  container: {
    alignItems: 'center'
  },
  content: {
    width: '100%'
  },
  title: {
    marginBottom: 20
  },
  directionContainer: {
    flexDirection: isTablet ? 'row' : 'column'
  },
  contentContainer: {
    flex: 1
  },
  numbersContainer: {
    flexDirection: 'row',
    flex: 1
  },
  stopsContainer: {
    flex: 1,
    marginRight: 5
  },
  weightContainer: {
    flex: 1,
    marginLeft: 5
  },
  buttonContainer: {
    width: '100%',
    flexDirection: isTablet ? 'row' : 'column',
    justifyContent: 'space-between',
    marginTop: isTablet ? 0 : 40
  },
  button: {
    minWidth: 120
  }
})

export default useStyles
